import { navigate } from 'gatsby';
import React, { ReactElement, useEffect, useState } from 'react';
import Block from '../../../../block';
import LibraryNav from '../library-nav';
import SearchResults from '../search-results';

interface IProps {
  children: any;
}

// The main part of the library page that shows the content.
// This is also where we handle some of our search functionality.
export default function LibraryMain({ children }: IProps): ReactElement {
  const [isShowingSearch, setIsShowingSearch] = useState<boolean>(false);
  const [searchInputVal, setSearchInputVal] = useState<string>('');
  const [searchQuery, setSearchQuery] = useState<string>('');

  // Putting this at the top because of limitations of gatsby's history
  // to not include search params.
  let searchParam;
  if (typeof window !== 'undefined') {
    const urlParams = new URLSearchParams(window.location.search);
    searchParam = urlParams.get('search');
  }

  const handleSearchChange = (value: string) => {
    setSearchInputVal(value);
  };

  const handleStartSearch = () => {
    navigate(`/library/?search=${searchInputVal}`);
    handleSearchChange(searchInputVal);
    setIsShowingSearch(true);
    setSearchQuery(searchInputVal);
  };

  const handleHideSearchResults = () => {
    setIsShowingSearch(false);
  };

  useEffect(() => {
    if (searchParam) {
      handleSearchChange(searchParam);
      setIsShowingSearch(true);
      setSearchQuery(searchParam);
    } else {
      setIsShowingSearch(false);
    }
  }, [searchParam]);

  return (
    <Block width={1200}>
      <div className="library-main__wrapper flex max-nav:block">
        <LibraryNav
          onSearchInputChange={handleSearchChange}
          onSearch={handleStartSearch}
          onHideSearchResults={handleHideSearchResults}
        />

        <main
          className="library-main mt-16 ml-16 w-full max-[1200px]:w-auto max-nav:m-0"
          id="main">
          {isShowingSearch ? (
            <SearchResults searchQuery={searchQuery} />
          ) : (
            <>{children}</>
          )}
        </main>
      </div>
    </Block>
  );
}
